import ActionCardGrid from '@rsa-digital/evo-shared-components/components/ActionCard/ActionCardGrid';
import React from 'react';
import { unwrapSingleton } from 'helpers/csTypeProcessors';
import { handleAndTrackLinkClick } from 'helpers/navigation';
import { StyledActionCard } from '../styles';
import { ActionCardsBlockProps } from '../types';

const ActionCardsBlock: React.FC<ActionCardsBlockProps> = ({ action_cards }) => (
  <ActionCardGrid className="actionCards" id={action_cards.html_id}>
    {action_cards.action_cards.map(
      ({ href, icon, heading, subheading, body, disabled, chevron_icon }, index) => (
        <StyledActionCard
          key={`${heading}-${index}`}
          data-cy={`CustomActionCard${index}`}
          href={href}
          icon={unwrapSingleton(icon)?.icon_code}
          heading={heading}
          subheading={subheading ?? undefined}
          body={body ?? undefined}
          onClick={handleAndTrackLinkClick(href, 'CustomActionCards', heading)}
          disabled={disabled}
          chevronIcon={unwrapSingleton(chevron_icon)?.icon_code}
        />
      )
    )}
  </ActionCardGrid>
);
export default React.memo(ActionCardsBlock);
